import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useState, type Dispatch, type SetStateAction } from "react";
import { toast } from "sonner";

export const useExplorations = ({
  archived = false,
}: { archived?: boolean } = {}) => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<{ loadExplorations: boolean }>({
    loadExplorations: true,
  });

  const loadExplorations = async (
    setExplorations: Dispatch<
      SetStateAction<{
        explorations: any[];
        rotations: any[];
        sessions: any[];
        teachers: any[];
      }>
    >,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, loadExplorations: true }));
      const response = await api(
        `/explorations?shape=teacher${archived ? "&archived=true" : ""}`,
        { method: "GET" },
        dispatch,
      );
      setExplorations({
        explorations: response.explorations,
        rotations: response.rotations,
        sessions: response.sessions,
        teachers: response.teachers,
      });
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, loadExplorations: false }));
    }
  };

  return { loadExplorations, loading };
};
